import {
  CalculateEmsTarpingBillRequest,
  CalculateEmsTarpingInvoiceRequest,
} from '@eigtech/tarpulator-types'
import { makeBasicQueryKeys } from '@eigtech/ui-shared-api'

export const tarpulatorBasePath = 'tarpulator'

export const calculateQueryKeys = {
  all: () => ['calculate'],
  ems: () => [...calculateQueryKeys.all(), 'ems'],
  emsTarping: () => [...calculateQueryKeys.ems(), 'tarping'],
  emsTarpingBill: (request: CalculateEmsTarpingBillRequest) => [
    calculateQueryKeys.emsTarping(),
    'bill',
    request,
  ],
  emsTarpingInvoice: (request: CalculateEmsTarpingInvoiceRequest) => [
    calculateQueryKeys.emsTarping(),
    'invoice',
    request,
  ],
}

export const regionsQueryKeys = {
  ...makeBasicQueryKeys('regions'),
  csv: () => [...regionsQueryKeys.list(), 'csv'],
  uploadCsv: () => [...regionsQueryKeys.all(), 'uploadCsv'],
}

export const vendorRatesQueryKeys = {
  ...makeBasicQueryKeys('vendorRates'),
  csv: () => [...vendorRatesQueryKeys.list(), 'csv'],
  uploadCsv: () => [...vendorRatesQueryKeys.all(), 'uploadCsv'],
}
